export default __webpack_public_path__ + "static/media/nfl.d5437df0.png";